import { render, staticRenderFns } from "./DetailEventOwner.vue?vue&type=template&id=ac09d92e&scoped=true&"
import script from "./DetailEventOwner.vue?vue&type=script&lang=js&"
export * from "./DetailEventOwner.vue?vue&type=script&lang=js&"
import style0 from "./DetailEventOwner.vue?vue&type=style&index=0&id=ac09d92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac09d92e",
  null
  
)

export default component.exports